/**
 * PostHog wrapper for the SPA.
 *
 * Initialised only when `VITE_POSTHOG_TOKEN` is set (production / preview).
 * In dev without the token, `PostHogProvider` renders children as a pass-through.
 */

import { PostHogProvider as PHProvider } from "@posthog/react";
import type { ReactNode } from "react";

const apiKey = import.meta.env.VITE_POSTHOG_TOKEN;
const apiHost = import.meta.env.VITE_POSTHOG_HOST;

const options = {
  ...(apiHost ? { api_host: apiHost } : {}),
  defaults: "2026-01-30",
  capture_pageview: false,
  capture_pageleave: true,
} as const;

export function PostHogProvider({ children }: { children: ReactNode }) {
  if (!apiKey) return children;

  return (
    <PHProvider apiKey={apiKey} options={options}>
      {children}
    </PHProvider>
  );
}
